module.exports = __webpack_public_path__ + "static/media/star.53d41de7.svg";